import React from 'react';
import PropTypes from 'prop-types';
import { builderWrapper, TextBlock } from 'cccisd-survey-common';
import { fields, validate, initialValues } from './settings.js';

export class Builder extends React.Component {
    static propTypes = {
        fields: PropTypes.object,
    };

    render() {
        const { instructionalText, warningText } = this.props.fields;

        return (
            <div>
                <TextBlock field={instructionalText} label="Instructional Text" comment="" />
                <TextBlock field={warningText} label="Warning Text" comment="" />
            </div>
        );
    }
}

export default builderWrapper({
    fields,
    validate,
    initialValues,
    withTemplate: false,
    withAccommodations: false,
})(Builder);
